import Vue from "vue";
import Vuex from "vuex";
import axios from 'axios';
import createPersistedState from 'vuex-persistedstate';
/* eslint-disable no-console */
Vue.use(Vuex);
axios.defaults.baseURL = process.env.NODE_ENV === 'production' ? 
      'https://api.petco.com.mx/' : 'http://localhost:3000';

/*axios.defaults.baseURL =  'http://localhost:3000';*/

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
      key: 'ecommerce',
    })
  ],
  state: {
    idUser: '',
    preguntas : {},
    idComentarioInsertado: '',
    comentarioInsertado: '',
    puntaje: '', 
    nombreCliente: '',
    paisCliente:'',
    nombreTienda: '',
    fecha: '',
    consecutivo: '',
    idCita: '',
    idTienda: '',
    idEmpleado: '',
    idUnico: '',
    idOrden: ''
  },
  getters: {
    idUser: (state) => {
      return state.idUser;
    },
    preguntas: (state) => {
      return state.preguntas;
    },
    idComentarioInsertado: (state) => {
      return state.idComentarioInsertado;
    },
    comentarioInsertado: (state) => {
      return state.comentarioInsertado;
    },
    puntaje: (state) => {
      return state.puntaje;
    },
    nombreCliente: (state) => {
      return state.nombreCliente;
    },
    paisCliente: (state) => {
      return state.paisCliente;
    },
    nombreTienda: (state) => {
      return state.nombreTienda
    },
    fecha: (state) => {
      return state.fecha;
    },
    consecutivo: (state) => {
      return state.consecutivo;
    },
    idCita: (state) => {
      return state.idCita;
    },
    idTienda: (state) => {
      return state.idTienda;
    },
    idEmpleado: (state) => {
      return state.idEmpleado;
    },
    idUnico: (state) => {
      return state.idUnico
    },
    idOrden: (state) => {
      return state.idOrden
    }
  }, 
  mutations: {
    idUser(state, idUser) {
      state.idUser = idUser;
    },
    preguntas(state, preguntas) {
      state.preguntas = preguntas;
    },
    idComentarioInsertado(state, idComentarioInsertado) {
      state.idComentarioInsertado = idComentarioInsertado;
    },
    comentarioInsertado(state, comentarioInsertado) {
      state.comentarioInsertado = comentarioInsertado;
    },
    puntaje(state, puntaje) {
      state.puntaje = puntaje;
    },
    nombreCliente(state, nombreCliente) {
      state.nombreCliente = nombreCliente;
    },
    paisCliente(state, paisCliente) {
      state.paisCliente = paisCliente;
    },
    nombreTienda(state, nombreTienda) {
      state.nombreTienda = nombreTienda;
    },
    fechaCita(state, fecha) {
      state.fecha = fecha;
    },
    consecutivo(state, consecutivo) {
      state.consecutivo = consecutivo;
    },
    idCitaGrooming(state, idCita) {
      state.idCita = idCita;
    },
    idTienda(state, tienda) {
      state.idTienda = tienda;
    },
    idEmpleado(state, empleado) {
      state.idEmpleado = empleado;
    },
    idUnico(state, idUnico) {
      state.idUnico = idUnico;
    }
  },
  actions: {
    LimpiaState({commit, state}) { 
      return new Promise((resolve, reject) => {
        commit('idUser', '');
        commit('preguntas', {});
        commit('idComentarioInsertado', '');
        commit('comentarioInsertado', '');
        commit('puntaje', '');
        commit('nombreCliente', '');
        commit('idEmpleado', '');
        commit('idUnico', '');
        commit('paisCliente', '');
        resolve(true);
      });
    },
    LimpiaStateTienda({commit, state}) { 
      return new Promise((resolve, reject) => {
        // commit('idUser', '');
        commit('preguntas', {});
        commit('idComentarioInsertado', '');
        commit('comentarioInsertado', '');
        commit('puntaje', '');
        commit('nombreCliente', '');
        commit('paisCliente', '');
        resolve(true);
      });
    },
    Predict({commit, state}, data) { 
      axios.defaults.baseURL = process.env.NODE_ENV === 'production' ? 
      'https://api.petco.com.mx/' : 'http://localhost:3000';
      return new Promise ((resolve, reject) => {
        axios.post("/predict_nps/get", data)
        .then((response: any) => {
          // axios.defaults.baseURL = BASE_URL;
          resolve(response.data);
        })
        .catch((error: any) => {
          reject(error);
        });
      });
    },
    GuardaComentario({commit, state}, data) { 
      axios.defaults.baseURL = process.env.NODE_ENV === 'production' ? 'https://api.petco.com.mx/' : 'http://localhost:3000';
      return new Promise ((resolve, reject) => {
        axios.post("/guarda_comentario_nps/create", data)
        .then((response: any) => {
          // axios.defaults.baseURL = BASE_URL;
          resolve(response.data)
        })
        .catch((error: any) => {
          reject(error);
        });
      });
    },
    EditaComentario({commit, state}, data) { 
      // axios.defaults.baseURL = process.env.NODE_ENV === 'production' ? 'https://api.petco.com.mx/' : 'http://localhost:3000';
      return new Promise ((resolve, reject) => {
        axios.post("/guarda_comentario_nps/edit", data)
        .then((response: any) => {
          // axios.defaults.baseURL = BASE_URL;
          resolve(response.data)
        })
        .catch((error: any) => {
          reject(error);
        });
      });
    },
    GuardaPreguntas({commit, state}, data) { 
      // axios.defaults.baseURL = process.env.NODE_ENV === 'production' ? 'https://api.petco.com.mx/' : 'http://localhost:3000';
      return new Promise ((resolve, reject) => {
        axios.post("/guarda_preguntas_nps/preguntas", data)
        .then((response: any) => {
          // axios.defaults.baseURL = BASE_URL;
          resolve(response.data)
        })
        .catch((error: any) => {
          reject(error);
        });
      });
    },
    ClubPetcoByIdEmarsys({commit, state}, id) { 
      // axios.defaults.baseURL = process.env.NODE_ENV === 'production' ? 'https://api.petco.com.mx/' : 'http://localhost:3000';
      return new Promise ((resolve, reject) => {
        axios.get('/get_club_petco_by_emarsys/' + id + '/get')
        .then((response: any) => {
          // axios.defaults.baseURL = BASE_URL;
          // console.log(response.data);
          resolve(response.data)
        })
        .catch((error: any) => {
          reject(error);
        });
      });
    },
    ClienteByClubPetco({commit, state}, id) { 
      // axios.defaults.baseURL = process.env.NODE_ENV === 'production' ? 'https://api.petco.com.mx/' : 'http://localhost:3000';
      return new Promise ((resolve, reject) => {
        axios.get('/get_club_petco_by_emarsys/club_petco/' + id + '/get')
        .then((response: any) => {
          resolve(response.data)
        })
        .catch((error: any) => {
          reject(error);
        });
      });
    },
    EmailSend({commit, state}, data){
      return new Promise ((resolve, reject) => {
        axios.post('/modulo_mailer/email', data)
        .then((response: any) => {
          resolve(response.data)
        })
        .catch((error: any) => {
          reject(error);
        });
      });
    },
    GetTienda({commit, state}, data){
      return new Promise ((resolve, reject) => {
        axios.get('/get_tienda_by_id/get_tienda/'+ data)
        .then((response: any) => {
          resolve(response.data)
        })
        .catch((error: any) => {
          reject(error);
        });
      });
    },
    GuardaPromedios({commit, state}, data) { 
      axios.defaults.baseURL = process.env.NODE_ENV === 'production' ? 'https://api.petco.com.mx/' : 'http://localhost:3000';
      return new Promise ((resolve, reject) => {
        axios.post("/promedio_nps/insertar_promedio", data)
        .then((response: any) => {
          resolve(response.data)
        })
        .catch((error: any) => {
          reject(error);
        });
      });
    },
    GetResultadosNPS({commit, state}, data){
      return new Promise ((resolve, reject) => {
        axios.get('/promedio_nps')
        .then((response: any) => {
          resolve(response.data)
        })
        .catch((error: any) => {
          reject(error);
        });
      });
    },
    GetResultadosByPredict({commit, state}, data){
      return new Promise ((resolve, reject) => {
        axios.get('/promedio_nps/promedios_by_subconceptos')
        .then((response: any) => {
          resolve(response.data)
        })
        .catch((error: any) => {
          reject(error);
        });
      });
    },
    GetResueltos({commit, state}, data){
      return new Promise ((resolve, reject) => {
        axios.get('/promedio_nps/contestados_nps')
        .then((response: any) => {
          resolve(response.data)
        })
        .catch((error: any) => {
          reject(error);
        });
      });
    },
    GetResueltosSemanaPrevia({commit, state}, data){
      return new Promise ((resolve, reject) => {
        axios.get('/promedio_nps/contestados_nps_prev')
        .then((response: any) => {
          resolve(response.data)
        })
        .catch((error: any) => {
          reject(error);
        });
      });
    },
    GetResueltosDosSemanaPrevia({commit, state}, data){
      return new Promise ((resolve, reject) => {
        axios.get('/promedio_nps/contestados_nps_prev_two')
        .then((response: any) => {
          resolve(response.data)
        })
        .catch((error: any) => {
          reject(error);
        });
      });
    },
    GetConteoSubconceptos({commit, state}, data){
      return new Promise ((resolve, reject) => {
        axios.get('/promedio_nps/subconceptos')
        .then((response: any) => {
          resolve(response.data)
        })
        .catch((error: any) => {
          reject(error);
        });
      });
    },
    GetPromediosByDistrito({commit, state}, data){
      return new Promise ((resolve, reject) => {
        axios.get('/promedio_nps/promedio_by_distrito')
        .then((response: any) => {
          resolve(response.data)
        })
        .catch((error: any) => {
          reject(error);
        });
      });
    },
    GetGroomingData({commit, state}, data){
      return new Promise ((resolve, reject) => {
        axios.post('/get_club_petco_by_emarsys/infoCita', data)
        .then((response: any) => {
          resolve(response.data)
        })
        .catch((error: any) => {
          reject(error);
        });
      });
    },
    GetPromediosNPS({commit, state}, data){
      return new Promise ((resolve, reject) => {
        axios.get('/promedio_nps/promedios_semana_previa')
        .then((response: any) => {
          resolve(response.data)
        })
        .catch((error: any) => {
          reject(error);
        });
      });
    },
    GetComentariosNPS({commit, state}, data){
      return new Promise ((resolve, reject) => {
        axios.get('/promedio_nps/comentarios')
        .then((response: any) => {
          resolve(response.data)
        })
        .catch((error: any) => {
          reject(error);
        });
      });
    },
    GetPromedios2NPS({commit, state}, data){
      return new Promise ((resolve, reject) => {
        axios.get('/promedio_nps/promedios_semana_ante_previa')
        .then((response: any) => {
          resolve(response.data)
        })
        .catch((error: any) => {
          reject(error);
        });
      });
    },
    GetPromediosByTienda({commit, state}, data){
      return new Promise ((resolve, reject) => {
        axios.get('/promedio_nps/promedios_by_tienda')
        .then((response: any) => {
          resolve(response.data)
        })
        .catch((error: any) => {
          reject(error);
        });
      });
    },
    GetTiendaInfo({commit, state}, data) {
      return new Promise((resolve, reject) => {
        axios.post('/get_club_petco_by_emarsys/infoTienda', data)
        .then((response) => {
          resolve(response.data)
        }).catch((err) => {
          resolve(err.response)
        });
      })
    },
    GetOpenRate({commit, state}, data){
      return new Promise ((resolve, reject) => {
        axios.get('/open_rate/')
        .then((response: any) => {
          resolve(response.data)
        })
        .catch((error: any) => {
          reject(error);
        });
      });
    },
    GetBOSSData({commit, state}, data){
      return new Promise ((resolve, reject) => {
        axios.post('/get_club_petco_by_emarsys/infoBoss',data)
        .then((response: any) => {
          resolve(response.data)
        })
        .catch((error: any) => {
          reject(error);
        });
      });
    },
    GetBOPUSData({commit, state}, data){
      return new Promise ((resolve, reject) => {
        axios.post('/get_club_petco_by_emarsys/infoBopus',data)
        .then((response: any) => {
          resolve(response.data)
        })
        .catch((error: any) => {
          reject(error);
        });
      });
    },
    GuardaEncuesta({commit, state}, data) {
      return new Promise((resolve, reject) => {
        axios.post('/guarda_encuesta_nps', data)
        .then((response) => {
          resolve(response.data)
        }).catch((err) => {
          resolve(err.response)
        });
      })
    },
  },
  
  modules: {}
});
